import { IConfig } from '../interfaces';

export const defaultConfig: IConfig = {
  env: process.env.PUBLIC_NODE_ENV,
  siteUrl: 'http://localhost:4000',
  apiUrl: 'http://localhost:8000',
};

export default defaultConfig;
